import type { Form } from '../../../../common/types/form';
import type { Child } from '../../../../common/types/child';

const changeOfAdressDataForm: Form<Child> = {
  key: 'changeOfAdressData',
  title: 'Info Adressänderung',
  fields: [
    {
      key: 'changeOfAddressSchool',
      label: 'Schule / KiGa',
      fieldTypes: 'checkbox',
    },
    {
      key: 'changeOfAddressAfterSchoolCare',
      label: 'Mittagsbetreuung / Hort',
      fieldTypes: 'checkbox',
    },
    {
      key: 'changeOfAddressYouthWelfareOffice',
      label: 'Jugendamt',
      fieldTypes: 'checkbox',
    },
    {
      key: 'changeOfAddressEarlyIntervention',
      label: 'Frühförderung',
      fieldTypes: 'checkbox',
    },
    {
      key: 'changeOfAddressKige',
      label: 'KiGe',
      fieldTypes: 'checkbox',
    },
    {
      key: 'changeOfAddressUvg',
      label: 'UVG',
      fieldTypes: 'checkbox',
    },
    {
      key: 'changeOfAddressZbfs',
      label: 'ZBFS',
      fieldTypes: 'checkbox',
    },
    {
      key: 'changeOfAddressDoctors',
      label: 'Ärzte',
      fieldTypes: 'checkbox',
    },
    {
      key: 'changeOfAddressTherapists',
      label: 'Therapeuten',
      fieldTypes: 'checkbox',
    },
  ],
};

export default changeOfAdressDataForm;
